import EmptyChatList, { VARIANTS } from "./EmptyChatList";
export default EmptyChatList;
export const EMPTY_CHAT_LIST_VARIANTS = VARIANTS;
